import { render, staticRenderFns } from "./Businessdetails.vue?vue&type=template&id=9055a434&scoped=true&"
import script from "./Businessdetails.vue?vue&type=script&lang=js&"
export * from "./Businessdetails.vue?vue&type=script&lang=js&"
import style0 from "./Businessdetails.vue?vue&type=style&index=0&id=9055a434&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9055a434",
  null
  
)

export default component.exports